import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getMaintenanceList } from "../../../redux/actions/maintenanceAction";
import { FETCH_MAINTENANCE_LIST } from "../../../redux/constants/type";
import AddButton from "../../../assets/icons/Card Add button.svg";
import { MaintenanceList } from "./MaintenanceList";
import { WorkMaintenanceModal } from "./WorkMaintenanceModal";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

export const Maintenance = ({ openNewMaintainacePopup = false }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const assetId = window.localStorage.getItem("assetId");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showAddModal, setShowAddModal] = useState(openNewMaintainacePopup);

  const maintenanceList = useSelector(
    (state) => state.maintenance.maintenanceList,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (assetId) {
      dispatch(getMaintenanceList(assetId));
    }
  }, []);

  useEffect(() => {
    if (maintenanceList) {
      dispatch({
        type: FETCH_MAINTENANCE_LIST,
        data: [],
      });
    }
  }, []);

  // useEffect(() => {
  //   return () => {
  //     localStorage.removeItem("currentAsset");
  //     localStorage.removeItem("assetId");
  //     localStorage.removeItem("assetMaintenanceId");
  //   };
  // }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <div>
      <Row>
        <Col md={6}>
          <p
            className="addTask d-flex justify-content-start align-items-center"
            onClick={() => setShowAddModal(true)}
          >
            <img className="me-2 mt-1 taskImg" src={AddButton} alt=""></img>
            <span>
              {/* Add Work */}
              {t("Add Work")}
            </span>
          </p>
          {showAddModal && (
            <WorkMaintenanceModal
              showWorkModal={showAddModal}
              setShowWorkModal={setShowAddModal}
              type="add"
            />
          )}
        </Col>
        <Col md={6} className="d-flex justify-content-end align-items-center">
          {/* Pagination comes here */}
          <section
            className="fr quotes-div-sec-2 assets-mobile-lenght"
            style={{ gap: "7px" }}
          >
            <p>
              {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
              {itemsPerPage * pageNumber > totalItems
                ? totalItems
                : itemsPerPage * pageNumber}
            </p>
            <p>of</p>
            <p>{totalItems}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber === 1) return;
                setPageNumber((p) => p - 1);
              }}
            >
              {"<"}
            </p>
            <p className="quote-current-page">{pageNumber}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber >= totalPages) return;
                setPageNumber((p) => p + 1);
              }}
            >
              {">"}
            </p>
          </section>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <MaintenanceList maintenanceList={maintenanceList} />
        </Col>
      </Row>
    </div>
  );
};
